// extracted by mini-css-extract-plugin
export default {"card":"DefaultAvatarCard_card__AGNux","header":"DefaultAvatarCard_header__d26sF"};